import React from "react";
import { useForm } from "@inertiajs/inertia-react";
import cx from "classnames";
import AppHead from "@/Components/AppHead";

const Login = () => {
    const { data, setData, errors, post, processing, reset, clearErrors } =
        useForm({
            email: "",
            password: "",
            remember: false,
        });

    const handleSubmit = (e) => {
        e.preventDefault();
        post(route("login"), {
            onFinish: () => reset("password"),
        });
    };

    const emailInputClass = cx(
        "block w-full appearance-none rounded-md border px-3 py-2 shadow-sm focus:outline-none sm:text-sm",
        {
            "focus:ring-indigo-500 border-gray-300 placeholder-gray-400 focus:border-indigo-500 ":
                !errors?.email,
            "border-red-300 text-red-900 placeholder-red-300 focus:ring-red-500 focus:border-red-500":
                errors?.email?.length,
        }
    );

    return (
        <div className="flex min-h-full flex-col justify-center py-12 sm:px-6 lg:px-8">
            <AppHead title={"Login"} />
            <div className="sm:mx-auto sm:w-full sm:max-w-md">
                <img
                    src="/images/logo.png"
                    alt="Logo"
                    className="mx-auto h-12 w-auto"
                />
                <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
                    Sign in to your account
                </h2>
            </div>

            <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
                <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
                    <form
                        action="#"
                        className="space-y-6"
                        onSubmit={handleSubmit}
                    >
                        <div>
                            <label
                                htmlFor="email"
                                className="block text-sm font-medium text-gray-700"
                            >
                                Email address
                            </label>
                            <div className="mt-1">
                                <input
                                    id="email"
                                    name="email"
                                    autoComplete="email"
                                    required
                                    type="email"
                                    className={emailInputClass}
                                    onChange={(e) =>
                                        setData("email", e.target.value)
                                    }
                                    onFocus={() => clearErrors("email")}
                                    value={data.email}
                                />
                            </div>
                            {errors.email && (
                                <p className="mt-2 text-sm text-red-600">
                                    {errors.email}
                                </p>
                            )}
                        </div>

                        <div>
                            <label
                                htmlFor="password"
                                className="block text-sm font-medium text-gray-700"
                            >
                                Password
                            </label>
                            <div className="mt-1">
                                <input
                                    type="password"
                                    name="password"
                                    id="password"
                                    autoComplete="current-password"
                                    required
                                    className="block w-full appearance-none rounded-md border border-gray-300 px-3 py-2 placeholder-gray-400 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                                    onChange={(e) =>
                                        setData("password", e.target.value)
                                    }
                                    onFocus={() => clearErrors("password")}
                                />
                            </div>
                        </div>

                        <div className="flex items-center justify-between">
                            <div className="flex items-center">
                                <input
                                    type="checkbox"
                                    id="remember"
                                    name="remember"
                                    className="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                                    onChange={(e) =>
                                        setData("remember", e.target.checked)
                                    }
                                />
                                <label
                                    htmlFor="remember"
                                    className="ml-2 block text-sm text-gray-900"
                                >
                                    Remember me
                                </label>
                            </div>
                        </div>

                        <div>
                            <button
                                type="submit"
                                className="btn-base btn-primary w-full"
                                disabled={processing}
                            >
                                Sign in
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Login;
